<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle=" Bibliothèque" />
            <LesBibliotheques />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesBibliotheques from './LesBibliotheques.vue';

export default {
    name: 'BibliothequesPage',
    components: {
        NavBar,
        PageTitle,
        LesBibliotheques,
        FooterComp,
    }
}
</script>